<template>
  <div class="cotent_news">
    <div class="content_top">
      <img src="@/assets/images/index/news.jpg" alt="" class="w100" />
      <!-- <h3>Who We Are</h3> -->
    </div>

    <div class="content_icon">
      <div class="news_top">
        <h3 class="custom-title">News</h3>
        <div class="menu_box">
          <router-link to="/Company-news">Company News</router-link>
          <router-link to="/Industry-news" class="hover"
            >Industry News</router-link
          >
        </div>
      </div>
      <div class="content">
        <h4>
          {{ article_info.title }}
        </h4>
        <div class="time_box">
          <img src="@/assets/images/icon/time.png" alt="" class="time" />
          <span>{{ article_info.add_time }}</span>
        </div>
        <div v-html="article_info.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["productName"],
  data() {
    return {
      article_info: [],
      cid: "",
      id: "",
    };
  },

  async created() {
    await this.fetchDetailData();
  },

  watch: {
    productName: {
      immediate: true,
      async handler(newId) {
        this.productName = newId;
        await this.fetchDetailData();
      },
    },
  },
  mounted() {
    console.log(this.$route.params.productName);
    this.fetchDetailData();
  },
  methods: {
    async fetchDetailData() {
      // 模拟异步数据获取，实际使用时替换为真实的 API 请求
      setTimeout(() => {
        // 这里可以根据 $route.params.id 获取对应的数据
        var that = this;

        axios({
          method: "get",
          url: `${this.$apiYf}/newsdetailapi.php?slug=${that.$route.params.productName}`,
          data: {
            catid: 1,
          },
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          that.article_info = res.data.article_info;
          document.title = res.data.article_info.pagetitle;
          document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.article_info.keywords)
          document.querySelector('meta[name="description"]').setAttribute('content', res.data.article_info.description)
          
          that.$emit("loaded");
        });
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.cotent_news {
  .content_icon {
    width: 72.9%;
    margin: 3vw auto;
    h3 {
      font-size: 48px;
      color: #ad1f24;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #ad1f24;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .content {
      h4 {
        font-size: 24px;
        color: #333;
        margin: 3vw 0 1vw;
      }
      @media (max-width: 768px) {
        h4 {
          font-size: 16px;
        }
      }
    }
    .news_top {
      display: flex;
      margin: 44px 0;
      align-items: baseline;
      justify-content: space-between;
    }
    .menu_box {
      display: flex;
      justify-content: space-between;
      @media (max-width: 768px) {
        a {
          width: calc(230px / 2) !important;
          height: calc(47px / 2) !important;
          line-height: calc(47px / 2) !important;
          font-size: 12px !important;
          padding: 0 10px;
        }
      }
      a {
        display: block;
        width: 15vw;
        height: 45px;
        color: #333;
        text-align: center;
        line-height: 45px;
        &.hover,
        &:hover {
          background: #ad1f24;
          color: #fff;
        }
      }
    }
    .time_box {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      padding-bottom: 1vw;
      border-bottom: solid 1px #ccc;
      margin-bottom: 2vw;
      img {
        margin-right: 4px;
      }
      @media (max-width: 768px) {
        font-size: 12px;
        .time {
          width: 14px;
          height: 14px;
        }
      }
    }
    ul {
      li {
        margin-top: 2vw;
        padding-bottom: 2vw;
        border-bottom: solid 1px #ccc;
        display: flex;
        .left_img {
          width: 20vw;
          margin-right: 2vw;
          flex-shrink: 0;
          height: 100%;
        }
        .text_container {
          flex: 1;
          h4 {
            font-size: 24px;
            color: #333333;
            margin-bottom: 22px;
            @media (max-width: 1440px) {
              margin-bottom: 10px;
            }
          }
          p {
            font-size: 14px;
            color: #666;
            line-height: 24px;
            margin-bottom: 60px;
            @media (max-width: 1440px) {
              margin-bottom: 10px;
            }
          }
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .detail {
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            margin-right: 4px;
          }
          span {
            color: #185fad;
            width: 10vw;
            height: 30px;
            border: solid 1px #185fad;
            display: block;
            text-align: center;
            line-height: 30px;
            &:hover {
              background: #185fad;
              color: #fff;
            }
          }
        }
      }
    }
  }
  @keyframes jump {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
}
</style>
